"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtMessage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtMessage = function SvgBtMessage(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.415 5H13.02C8.597 5 5 8.597 5 13.019c0 4.422 3.597 8.019 8.019 8.019h1.396c.69 0 1.374-.088 2.036-.261l2.062 2.061a.552.552 0 00.942-.39v-3.192a8.096 8.096 0 002.108-2.598 7.932 7.932 0 00.871-3.639C22.434 8.597 18.837 5 14.415 5zm4.156 13.547a.552.552 0 00-.22.44v2.13l-1.35-1.35a.552.552 0 00-.552-.137 6.918 6.918 0 01-2.034.305H13.02a6.923 6.923 0 01-6.916-6.916 6.923 6.923 0 016.916-6.916h1.396a6.923 6.923 0 016.916 6.916 6.865 6.865 0 01-2.76 5.528z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.39 12.821a.43.43 0 100-.862.43.43 0 000 .862zM16.875 11.96h-4.922a.43.43 0 000 .861h4.922a.43.43 0 100-.861zM16.875 14.304h-6.484a.43.43 0 100 .861h6.484a.43.43 0 100-.861z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.08
  }));
};

exports.SvgBtMessage = SvgBtMessage;